import _ from 'lodash';
import template from './cardOrdinacija.html';

class CardOrdinacijaController {
    constructor($scope) {
        this.items = this.items || [];
        this.rows = [];
        $scope.$watch('vm.items', this.itemsChanged());
    }

    itemsChanged() {
        return (newValue, oldValue) => {
            var items = _.map(newValue, _.clone);
            this.rows = [];
            for (var i=0, j=items.length; i<j; i = i + 4) {
                this.rows.push(items.splice(0, 4));
            }
        };
    }

    edit(item) {
        this.onEdit({item: item});
    }
}

CardOrdinacijaController.$inject = ['$scope'];

const CardOrdinacijaComponent = {
    restrict: 'E',
    templateUrl: template,
    controller: CardOrdinacijaController,
    controllerAs: 'vm',
    bindings: {
        items: '<',
        onEdit: '&'
    }
};

export {CardOrdinacijaComponent};



// WEBPACK FOOTER //
// ./app/components/ordinacija/cardOrdinacija.component.js